var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var icon = {
    // eslint-disable-next-line quotes
    error: "data:image/svg+xml,%3Csvg id='Layer_1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 128 128'%3E%3Ctitle%3Ebold/exclamation-circle-bold%3C/title%3E%3Cpath fill='XXXXX' id='Combined-Shape' class='st0' d='M109.2 18.8C96.1 6.2 81 0 64 0S31.9 6.2 18.8 18.8C6.2 31.9 0 47 0 64s6.2 32.1 18.8 45.2C31.9 121.8 47 128 64 128s32.1-6.2 45.2-18.8C121.8 96.1 128 81 128 64s-6.2-32.1-18.8-45.2zM64.5 21c2.3 0 4.2.7 5.8 2s2.2 3 2.2 5c0 .7-.1 1.8-.2 3.5l-2 49.5c0 1.1-1 2-2.1 2h-6.5c-1.1 0-2.1-.9-2.1-2l-3.4-49c-.2-1.5-.2-2.4-.2-2.8 0-2.8.7-4.9 2.2-6.2 1.4-1.3 3.5-2 6.3-2zm5.7 83c-1.7 1.5-3.6 2.2-5.9 2.2-2.3 0-4.2-.8-5.9-2.4s-2.5-3.6-2.5-6 .7-4.3 2.2-5.6c1.8-1.7 3.9-2.5 6.1-2.5 2.3 0 4.2.8 5.8 2.4s2.4 3.5 2.4 5.9-.6 4.3-2.2 6z'/%3E%3C/svg%3E",
};
var getIcon = function (icon, size, fill, label) {
    if (label === void 0) { label = ''; }
    var fillEncoded = fill.replace('#', '%23');
    var dataUri = icon.replace('XXXXX', fillEncoded);
    return {
        label: label,
        display: 'inline-block',
        backgroundSize: 'contain',
        backgroundPosition: 'center center',
        backgroundRepeat: 'no-repeat',
        backgroundImage: "url(\"".concat(dataUri, "\")"),
        width: size,
        height: size,
    };
};
export var outerWrapper = {
    position: 'relative',
    ':before': {
        background: '#DFE4E8',
        bottom: 0,
        content: '""',
        display: 'block',
        height: 4,
        left: 0,
        position: 'absolute',
        width: '100%',
    },
};
export var errorIcon = __assign(__assign({}, getIcon(icon.error, 16, '#CC0821')), { marginRight: 4, verticalAlign: 'top' });
export var wrapper = {
    overflow: 'hidden',
    position: 'relative',
    ':before': {
        background: "linear-gradient(90deg, rgba(166, 176, 186, 0.3) 0%, transparent 100%)",
        content: '""',
        display: 'block',
        height: '100%',
        left: 0,
        opacity: 1,
        pointerEvents: 'none',
        position: 'absolute',
        top: 0,
        width: 46,
        zIndex: 10,
    },
    ':after': {
        background: 'linear-gradient(90deg, transparent 0%, rgba(166, 176, 186, 0.3) 100%)',
        content: '""',
        display: 'block',
        height: '100%',
        opacity: 1,
        pointerEvents: 'none',
        position: 'absolute',
        right: 0,
        top: 0,
        width: 46,
        zIndex: 10,
    },
};
export var wrapperScrollStart = {
    ':before': {
        opacity: '0 !important',
    },
};
export var wrapperScrollEnd = {
    ':after': {
        opacity: '0 !important',
    },
};
export var container = {
    background: '#FFFFFF00',
    boxSizing: 'border-box',
    display: 'flex',
    flexWrap: 'nowrap',
    overflowScrolling: 'touch',
    overflowStyle: 'none',
    overflowX: 'auto',
    scrollbarWidth: 'none',
    scrollPadding: 0,
    scrollSnapType: 'x mandatory',
    scrollSnapStop: 'always',
    height: '52px',
    width: '100%',
    '::-webkit-scrollbar': {
        display: 'none',
    },
};
export var tabs = {
    background: '#FFFFFF00',
    display: 'block',
    fontSize: 0,
    margin: 0,
    listStyleType: 'none',
    padding: 0,
    outline: 'none',
    whiteSpace: 'nowrap',
};
export var tab = {
    background: 'none',
    borderRadius: 0,
    display: 'inline-block',
    fontSize: 14,
    fontWeight: 600,
    lineHeight: 16 + 'px',
    margin: 0,
    padding: 0,
};
export var tabPadding = {
    padding: 32,
};
export var target = {
    background: 'none',
    border: 'none',
    color: '#323E48',
    display: 'block',
    padding: '18px 20px',
    position: 'relative',
    textDecoration: 'none',
    ':before': {
        background: '#DFE4E8',
        bottom: 0,
        content: '""',
        display: 'block',
        height: 4,
        left: 0,
        position: 'absolute',
        width: '100%',
    },
    ':hover': {
        color: '#323E48',
        background: '#0000000A',
        ':before': {
            background: '#75828C',
            bottom: 0,
            content: '""',
            display: 'block',
            height: 4,
            left: 0,
            position: 'absolute',
            width: '100%',
        },
    },
    ':hover:active': {
        background: '#00000014',
        ':before': {
            background: '#626F79',
            bottom: 0,
            content: '""',
            display: 'block',
            height: 4,
            left: 0,
            position: 'absolute',
            width: '100%',
        },
    },
};
export var targetError = __assign(__assign({}, target), { color: '#CC0821', ':hover': {
        color: '#CC0821',
        background: '#0000000A',
        ':before': {
            background: '#75828C',
            bottom: 0,
            content: '""',
            display: 'block',
            height: 4,
            left: 0,
            position: 'absolute',
            width: '100%',
        },
    } });
export var targetActive = __assign(__assign({}, target), { background: '#F2F7FF', fontWeight: 600, color: '#000000', ':before': {
        background: '#1454CC',
        bottom: 0,
        content: '""',
        display: 'block',
        height: 4,
        left: 0,
        position: 'absolute',
        width: '100%',
    }, ':hover': {
        color: '#000000',
        ':before': {
            background: '#1454CC',
            bottom: 0,
            content: '""',
            display: 'block',
            height: 4,
            left: 0,
            position: 'absolute',
            width: '100%',
        },
    } });
export var targetActiveError = __assign(__assign({}, targetError), { color: '#000000', background: '#FFEBED', fontWeight: 600, ':before': __assign(__assign({}, targetActive[':before']), { background: '#CC0821' }), ':hover': {
        color: '#000000',
        ':before': {
            background: '#CC0821',
            bottom: 0,
            content: '""',
            display: 'block',
            height: 4,
            left: 0,
            position: 'absolute',
            width: '100%',
        },
    } });
export var emblem = {
    background: 'none',
    border: "1px solid ".concat('#323E48'),
    borderRadius: 20,
    color: '#323E48',
    fontSize: 14,
    fontWeight: 600,
    height: 20,
    lineHeight: 16 + 'px',
    marginLeft: "".concat(4, "px"),
    minWidth: 20,
    padding: '0 7px',
    width: 'auto',
};
export var emblemActive = __assign(__assign({}, emblem), { borderColor: '#2C67A0', color: '#2C67A0' });
export var emblemError = __assign(__assign({}, emblem), { borderColor: '#CC0821', color: '#CC0821' });
